import React from 'react';
import FormularioContacto from '../components/formularios/FormularioContacto';
import SEO from '../components/SEO';

const contactCards = [
  {
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
      </svg>
    ),
    label: 'Correo',
    value: 'contacto@atst.cl',
    href: 'mailto:contacto@atst.cl',
    badge: 'Respuesta 24 hrs',
  },
  {
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
        <path strokeLinecap="round" strokeLinejoin="round" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
      </svg>
    ),
    label: 'Dirección',
    value: 'Providencia, Región Metropolitana, Chile',
    href: 'https://www.google.com/maps/place/Padre+Mariano+82,+Oficina+503,+7500026+Providencia',
    badge: 'Ver en mapa',
    target: '_blank',
  },
];

function Contacto() {
  return (
    <main className="bg-gray-50 min-h-screen">
      <SEO
        title="Contacto"
        description="Contáctanos para comprar, arrendar o recibir soporte en equipos de radiocomunicación profesional en Chile."
        canonicalPath="/contacto"
      />

      {/* Hero banner */}
      <div className="w-full h-40 md:h-56 flex flex-col justify-center items-center relative overflow-hidden">
        <img
          src="https://dps2wxsijib8x.cloudfront.net/atst/BannerPagina.webp"
          alt="Contacto ATST"
          className="object-cover w-full h-full absolute inset-0 z-0"
        />
        <div className="absolute inset-0 z-0 bg-gradient-to-r from-[#0f274b]/95 via-[#0f274b]/80 to-[#0f274b]/50" />
        <div className="relative z-10 text-center px-4">
          <span className="inline-block bg-[#00BEE7]/20 border border-[#00BEE7]/40 text-[#00BEE7] text-xs font-bold uppercase tracking-widest px-4 py-1.5 rounded-full mb-3">
            Contáctanos
          </span>
          <h1 className="text-2xl sm:text-3xl md:text-5xl font-black text-white tracking-tight">
            Hablemos
          </h1>
        </div>
      </div>

      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-10 md:py-14">

        {/* Tarjetas de contacto */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-10">
          {contactCards.map((card) => (
            <a
              key={card.label}
              href={card.href}
              target={card.target || '_self'}
              rel={card.target === '_blank' ? 'noopener noreferrer' : undefined}
              className="group bg-white rounded-2xl border border-gray-100 shadow-sm p-5 flex flex-col items-start hover:border-[#00BEE7]/50 hover:shadow-md transition-all duration-200"
            >
              <div className="flex items-center justify-center w-11 h-11 rounded-xl mb-3 transition-colors duration-200 bg-[#00BEE7]/10 text-[#007fa0] group-hover:bg-[#00BEE7]/20">
                {card.icon}
              </div>
              <p className="text-xs font-extrabold text-gray-400 uppercase tracking-widest mb-1">{card.label}</p>
              <p className="text-sm font-bold text-[#0f274b] leading-snug whitespace-pre-line">{card.value}</p>
              <span className="mt-2 text-[10px] font-bold px-2 py-0.5 rounded-full bg-[#00BEE7]/10 text-[#007fa0]">
                {card.badge}
              </span>
            </a>
          ))}
        </div>

        {/* Grid: formulario + mapa */}
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-8">

          {/* Formulario */}
          <div className="lg:col-span-3">
            <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden">
              <div className="bg-[#0f274b] px-6 py-5">
                <h2 className="font-extrabold text-white text-lg">Formulario de contacto</h2>
                <p className="text-blue-200 text-sm mt-1">
                  Completa el formulario y un asesor te contactará a la brevedad.
                </p>
              </div>
              <div className="p-6">
                <FormularioContacto />
              </div>
            </div>
          </div>

          {/* Mapa + info */}
          <div className="lg:col-span-2 space-y-5">
            {/* Mapa */}
            <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden">
              <div className="h-64 lg:h-80">
                <iframe
                  title="Mapa de ubicación ATST"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3261.363284775294!2d-70.61657350234262!3d-33.42607573155116!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9662cf63905aaaab%3A0x2bb2f0323592d648!2sPadre%20Mariano%2082%2C%20Oficina%20503%2C%207500026%20Providencia%2C%20Regi%C3%B3n%20Metropolitana!5e0!3m2!1ses-419!2scl!4v1749766169657!5m2!1ses-419!2scl"
                  className="w-full h-full"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                />
              </div>
              <div className="px-4 py-3 bg-gray-50 border-t border-gray-100 flex items-center gap-2">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-[#00BEE7] shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
                <p className="text-xs text-gray-600 font-medium">Providencia, Región Metropolitana, Chile</p>
              </div>
            </div>

            {/* Horarios */}
            <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-5">
              <h3 className="font-extrabold text-[#0f274b] text-sm mb-3 border-l-4 border-[#00BEE7] pl-3">Horario de atención</h3>
              <div className="space-y-2">
                {[
                  { day: 'Lunes – Viernes', hours: '09:00 – 18:00 hrs.' },
                  { day: 'Sábado', hours: 'Con cita previa' },
                  { day: 'Domingo', hours: 'Cerrado' },
                ].map((item) => (
                  <div key={item.day} className="flex items-center justify-between text-sm">
                    <span className="text-gray-600 font-medium">{item.day}</span>
                    <span className="text-[#0f274b] font-bold text-xs bg-gray-50 px-2.5 py-1 rounded-full">{item.hours}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>

        </div>
      </div>
    </main>
  );
}

export default Contacto;
